import React from 'react'
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, makeStyles, IconButton, Paper } from '@material-ui/core'
import Button from '../Button/Button';
import InfoIcon from '@material-ui/icons/Info';
import Draggable from 'react-draggable';
const useStyles = makeStyles(theme => ({
    dialog: {
        //padding: theme.spacing(2),
        position: 'absolute',
        top: theme.spacing(5)
    },
    dialogTitle: {
        textAlign: 'left',
        background: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        padding:'8px',
    },
    dialogContent: {
        textAlign: 'left',
        padding:'20px',
    },
   // dialog
    dialogAction: {
        justifyContent: 'right'
    },
    titleIcon: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        marginRight:'10px',
        '&:hover': {
            backgroundColor: theme.palette.warning.dark,
            cursor: 'default'
        },
        '& .MuiSvgIcon-root': {
            fontSize: '2rem',
        }
    }
}))

export default function UnSavedPrompt(props) {

    const { showDialog, confirmNavigation, cancelNavigation} = props;
    const classes = useStyles()
    function PaperComponent(props) {
        return (
          <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
          </Draggable>
        );
      }
    return (
        <Dialog open={showDialog} classes={{ paper: classes.dialog }}   PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title" >
            <DialogTitle className={classes.dialogTitle} style={{ cursor: 'move' }} id="draggable-dialog-title">
            <IconButton disableRipple className={classes.titleIcon}>
                    <InfoIcon />
                </IconButton>
                 You Have Unsaved Changes!
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Typography variant="subtitle1" component={'p'}>
                    If You Close This Dialog, You will Lose All Changes You Have Made.
                </Typography>
                <Typography variant="h6" component={'h6'}>
                    Are You Sure, You Wish To Leave The Page?
                </Typography>
            </DialogContent>
            <DialogActions className={classes.dialogAction}>
                <Button
                    label="No"
                   
                    onClick={cancelNavigation} />
                <Button
                    label="Yes"
                  
                    onClick={confirmNavigation} />
            </DialogActions>
        </Dialog>
    )
}